import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Typography } from "@material-ui/core";

import TableLayout from "components/TableLayout";
import TableText from "components/TableText";
import EditClientButton from "screens/Clients/components/EditClientButton";
import ClientActiveSwitch from "screens/Clients/components/ClientActiveSwitch";

import { fetchClientsList } from "store/client/actions";

import { SUCCESS_STATUS } from "components/MessageService/constants";

const ClientsTable = () => {
  const dispatch = useDispatch();

  const { list } = useSelector(({ clientReducer }) => clientReducer);
  const { loading, messagePayload } = useSelector(
    ({ helperReducer }) => helperReducer
  );

  useEffect(() => {
    dispatch(fetchClientsList());
  }, [dispatch]);

  useEffect(() => {
    if (
      messagePayload &&
      messagePayload.type === SUCCESS_STATUS &&
      messagePayload.shouldUpdate
    ) {
      dispatch(fetchClientsList());
    }
  }, [dispatch, messagePayload]);

  const columns = [
    {
      name: "status",
      displayName: "Active",
      Component: ClientActiveSwitch,
      props: {
        width: 40,
      },
    },
    {
      name: "code",
      displayName: "Code",
      Component: TableText,
      shouldSort: true,
      props: {
        width: 80,
      },
    },
    {
      name: "name",
      displayName: "Name",
      Component: TableText,
      shouldSort: true,
      props: {
        width: 200,
      },
    },
    {
      name: "email",
      displayName: "Email",
      Component: TableText,
      shouldSort: true,
      props: {
        width: 200,
      },
    },
    {
      name: "contactPersonName",
      displayName: "Contact Person",
      Component: TableText,
      shouldSort: true,
      props: {
        width: 150,
      },
    },
  ];

  return (
    <TableLayout
      data={list}
      columns={columns}
      loading={loading}
      noItemsMessage={<Typography>There are no clients to list.</Typography>}
      actions={[
        { Component: EditClientButton, permission: "CLIENTS.CLIENTS_UPDATE" }
      ]}
    />
  );
};

export default ClientsTable;

